nbf.url = function(){
	var fChangeHash=[];
	var hashAnterior = "";
	var hashIgnorarChange = false;
	
	/**
	 * Lee los parámetros por get actuales y crea un objeto
	 * @return object Parámetros con sus valores
	 */
	function leerUrlParams(){
		return nbf.url.parseUrlParams(window.location.search.substring(1));
	}
	
	/**
	 * Lee unos parámetros en formato a=x&b=y y crea un objeto
	 * @param string params Lista de parámetros a leer
	 * @return object Objeto leído 
	 */
	function parseUrlParams(params){
		if(params.length>0){
			var asigs = params.split("&");
			var obj = {};
			for(var i=0;i<asigs.length;i++){
				var asig = asigs[i].split("=");
				obj[asig[0]] = decodeURIComponent(asig[1]);
			}
			return obj;
		}else
			return {};
	}

	/**
	 * Compone los parámetros pasados en una cadena var1=x1&var2=x2...
	 * @param object params Lista de parámetros a crear
	 * @return string Cadena en formato var1=x1&var2=x2...
	 */
	function componerUrlParams(params){
		var cadena = [];
		for(var p in params){
			if(p.charAt(0)!="_"){ //todos los campos que empiezan por _ se consideran internos y no se componen
				var val = params[p]; 
				if($.isPlainObject(val) || $.isArray(val))
					val = nbf.toJSON(val);
				cadena.push(p+"="+val);
			}
		}
		return cadena.join("&");
	}

	/**
	 * Lee todos los parámetros pasados en la cadena hash
	 * @return Object Objeto con todos los parámetros
	 */
	function leerParamsHash(){
		var hash = window.location.hash.substring(1);
		return nbf.url.parseUrlParams(hash);
	}

	/**
	 * Lee el parámetro pasado de la cadena hash
	 * @param string param Nombre del parámetro a leer
	 */
	function leerParamHash(param){
		var params = leerParamsHash();
		return params[param];
	}

	/**
	 * Escribe el parámetro pasado en la cadena hash de la URL actual
	 * @param string param Nombre del parámetro
	 * @param string valor Valor del parámetro
	 * @param bool ignorarChange A true si queremos que no se lance el evento change
	 */
	function limpiarParamsHash(ignorarChange){
		hashIgnorarChange = (ignorarChange?true:false);
		window.location.hash = "#";
	}

	/**
	 * Escribe los parámetros pasados (Object) en la cadena hash de la URL actual
	 * @param Object params Parámetros a escribir
	 * @param bool ignorarChange A true si queremos que no se lance el evento change
	 */
	function escribirParamsHash(params,ignorarChange){
		var hash = window.location.hash.substring(1);
		var p = nbf.url.parseUrlParams(hash);
		for(var i in params){
			if(i.charAt(0)!="_")
				p[i] = params[i];
		}
		hashIgnorarChange = (ignorarChange?true:false);
		window.location.hash = "#"+nbf.url.componerUrlParams(p);
	}

	/**
	 * Escribe el parámetro pasado en la cadena hash de la URL actual
	 * @param string param Nombre del parámetro
	 * @param string valor Valor del parámetro
	 * @param bool ignorarChange A true si queremos que no se lance el evento change
	 */
	function escribirParamHash(param,valor,ignorarChange){
		var hash = window.location.hash.substring(1);
		var params = nbf.url.parseUrlParams(hash);
		params[param] = valor;
		hashIgnorarChange = (ignorarChange?true:false);
		window.location.hash = "#"+nbf.url.componerUrlParams(params);
	}
	
	/**
	 * Detecta el cambio en parámetro hash y lanza la función pasada (sin parámetros)
	 * @param function funcion Función a llamar cuando cambie el hash
	 */
	function changeParamsHash(funcion){
		fChangeHash.push(funcion);
		if(fChangeHash.length==1){
			hashAnterior = window.location.hash;
			setInterval(
				function(){
					if(hashAnterior!=window.location.hash){
						if(!hashIgnorarChange){
							for(var i in fChangeHash)
								fChangeHash[i]();
						}
						hashAnterior = window.location.hash;
						//reseteamos el bool para que al siguiente no se ignore
						hashIgnorarChange = false;
					}
				},
				1000
			);
		}
	}
	
	return {
		"leerUrlParams":leerUrlParams,
		"parseUrlParams":parseUrlParams,
		"componerUrlParams":componerUrlParams,
		"leerParamsHash":leerParamsHash,
		"leerParamHash":leerParamHash,
		"limpiarParamsHash":limpiarParamsHash,
		"escribirParamHash":escribirParamHash,
		"escribirParamsHash":escribirParamsHash,
		"changeParamsHash":changeParamsHash
	};
}();
